export default __webpack_public_path__ + "maps-examples-user-tracking-mode-thumbnail-960-e0f870244e309d89990ade701944f1f2.png";